import {
  ShareEpisodeFragment,
  ShareMessageFragment,
  ShareProfileRoomFragment,
  ShareRoomFragment,
  ShareRoomMemberFragment,
  ShareUserProfileFragment,
} from "~/__generated__/graphql"
import { getMetaContent, getMetaContentMaybe } from "~/common/get-meta-content"

export const getInviterData = () => {
  return getMetaContentMaybe<ShareRoomMemberFragment>("inviter-data", {
    json: true,
  })
}

export const getInviteRoomIds = (): string[] =>
  getMetaContentMaybe<string[]>("invite-room-ids", { json: true }) ?? []

export const getMessageData = () => {
  return getMetaContentMaybe<ShareMessageFragment>("message-data", {
    json: true,
  })
}

export const getEpisodeData = () => {
  return getMetaContentMaybe<ShareEpisodeFragment>("episode-data", {
    json: true,
  })
}

export const getRoomData = () => {
  // SPA application will not be rendered server-side if a given room cannot be found, or sharing is disabled.
  // Therefore, it's safe to assume that data will always be present when this code runs.
  return getMetaContent<ShareRoomFragment>("room-data", { json: true })
}

export const getTopMessages = () => {
  const messages = getMetaContentMaybe<ShareMessageFragment[]>("top-messages", { json: true })
  return messages?.length ? messages : null
}

export const getProfileData = () => {
  // Only rendered server-side for users with a profile page, like room-data above.
  return getMetaContent<ShareUserProfileFragment>("profile-data", { json: true })
}

export const getProfileRooms = (): ShareProfileRoomFragment[] =>
  getMetaContentMaybe<ShareProfileRoomFragment[]>("profile-rooms", { json: true }) ?? []
